import { AvatarSpeakingIndicatorView } from "@bezoned/shared/components/avatar-speaking-indicator-view.jsx";
import { computeEffectiveSpeaking } from "@bezoned/shared/utils/compute-effective-speaking.js";

import { useUserSpeaking } from "./use-user-speaking.js";

interface AvatarSpeakingIndicatorProps {
  userId: string;
  connected: boolean;
  isMuted: boolean;
  isVisibleInContext: boolean;
}

export const AvatarSpeakingIndicator = ({
  userId,
  connected,
  isMuted,
  isVisibleInContext,
}: AvatarSpeakingIndicatorProps) => {
  const speakingState = useUserSpeaking(userId);
  const effectiveSpeakingState = computeEffectiveSpeaking({
    connected,
    isMuted,
    isVisibleInContext,
    raw: speakingState,
  });

  return <AvatarSpeakingIndicatorView {...effectiveSpeakingState} />;
};
